export const actionSelect =
    '<div class="toolbar-select">\n'
    + "    <select></select>\n"
    + '    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n'
    + '        <path d="M11.6464 13.6464C11.8417 13.4512 12.1583 13.4512 12.3536 13.6464L16.5 17.7929L20.6464 13.6464C20.8417 13.4512 21.1583 13.4512 21.3536 13.6464C21.5488 13.8417 21.5488 14.1583 21.3536 14.3536L16.8536 18.8536C16.6583 19.0488 16.3417 19.0488 16.1464 18.8536L11.6464 14.3536C11.4512 14.1583 11.4512 13.8417 11.6464 13.6464Z" fill="#201F1E"/>\n'
    + "    </svg>\n"
    + "</div>\n";
